module.exports = __webpack_public_path__ + "img/3.e704c386.jpg";